let duration;
let distanceRatio;
let startTimer;

// stop

const stopAutoplay = (swiperInstance) => {
  console.log('stopping autoplay');
  if (!swiperInstance) return;
  swiperInstance.setTranslate(swiperInstance.getTranslate());
  const currentSlideWidth = swiperInstance.slides[swiperInstance.activeIndex].offsetWidth;
  distanceRatio = Math.abs((currentSlideWidth * swiperInstance.activeIndex + swiperInstance.getTranslate()) / currentSlideWidth);
  duration = swiperInstance.params.speed * distanceRatio;
  swiperInstance.autoplay.stop();
};

const startAutoplay = (swiperInstance, delay = duration) => {
  if (!swiperInstance) return;
  swiperInstance.slideTo(swiperInstance.activeIndex, delay, false);
  swiperInstance.autoplay.start();
};

window.initMarqueeCarousel = function(sectionId) {
  var swiper = new Swiper(`#shopify-section-${sectionId} .swiper`, {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: true,
    speed: 8000,
    allowTouchMove: false,
    preventClicks: false, 
    preventClicksPropagation: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        var videoMedias = document.querySelectorAll(`#shopify-section-${sectionId} video-media`);
        videoMedias.forEach(function(video) {
          setTimeout(function() {
            video.click();
          }, 100);
        });
      }
    }
  });

  // YouTube video player functionality
  const youtubeContainers = document.querySelectorAll(`#shopify-section-${sectionId} .youtube-video-container`);

  youtubeContainers.forEach((container) => {
    const playButton = container.querySelector('.youtube-play-button');
    const youtubeId = container.dataset.youtubeId;

    if (playButton && youtubeId) {
      playButton.addEventListener('click', function () {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&enablejsapi=1`;
        iframe.className = 'youtube-video-frame';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');

        container.innerHTML = '';
        container.appendChild(iframe);

        // Force focus on iframe to ensure autoplay works
        setTimeout(() => {
          iframe.focus();
        }, 100);
      });
    }
  });

  // Add mouseenter/mouseleave listeners to carousel for autoplay control
  const carouselEl = document.querySelector(`#shopify-section-${sectionId} .swiper`);
  let touchTimeoutId;
  if (carouselEl) {
    carouselEl.addEventListener('mouseenter', () => stopAutoplay(swiper));
    carouselEl.addEventListener('mouseleave', () => startAutoplay(swiper));
    carouselEl.addEventListener('touchstart', () => {
      stopAutoplay(swiper);
      if (touchTimeoutId) {
        clearTimeout(touchTimeoutId);
      }
      touchTimeoutId = setTimeout(() => {
        startAutoplay(swiper);
        touchTimeoutId = null;
      }, 2000);
    }, {passive: true});
    document.addEventListener('touchstart', function(event) {
      if (!carouselEl.contains(event.target)) {
        startAutoplay(swiper);
      }
    }, {passive: true});
  }

  // Hosted video play/pause toggle
  const hostedToggles = document.querySelectorAll(`#shopify-section-${sectionId} .hosted-video-toggle`);
  hostedToggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const wrapperId = btn.getAttribute('data-video-id');
      const wrapper = document.getElementById(wrapperId);
      if (!wrapper) return;
      const video = wrapper.querySelector('video');
      if (!video) return;
      const pauseIcon = btn.querySelector('.hosted-video-pause-icon');
      const playIcon = btn.querySelector('.hosted-video-play-icon');
      if (video.paused) {
        video.play();
        if (pauseIcon) pauseIcon.style.display = 'inline';
        if (playIcon) playIcon.style.display = 'none';
      } else {
        video.pause();
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playIcon) playIcon.style.display = 'inline';
      }
    });
    // Set initial state based on video
    const wrapperId = btn.getAttribute('data-video-id');
    const wrapper = document.getElementById(wrapperId);
    if (wrapper) {
      const video = wrapper.querySelector('video');
      const pauseIcon = btn.querySelector('.hosted-video-pause-icon');
      const playIcon = btn.querySelector('.hosted-video-play-icon');
      if (video && video.paused) {
        if (pauseIcon) pauseIcon.style.display = 'inline';
        if (playIcon) playIcon.style.display = 'none';
      } else if (video) {
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playIcon) playIcon.style.display = 'inline';
      }
    }
  });
};
